module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-panel md-elevation-1",
    attrs: {
      "id": "address-type"
    }
  }, [_c('div', {
    staticClass: "md-layout"
  }, [_c('div', {
    staticClass: "md-layout-item"
  }, [_c('md-button', {
    staticClass: "md-accent md-dense",
    attrs: {
      "to": {
        name: 'AddressTypes',
        query: _vm.$route.query
      }
    }
  }, [_vm._v("Отмена")])], 1), _c('div', {
    staticClass: "md-layout-item md-layout md-alignment-top-right"
  }, [_c('md-button', {
    staticClass: "md-primary md-dense",
    on: {
      "click": _vm.saveAddressType
    }
  }, [_vm._v("Сохранить")])], 1)]), _c('md-field', {
    class: {
      'md-invalid': _vm.errors.has('name')
    }
  }, [_c('label', [_vm._v("Название*")]), _c('md-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "name"
    },
    model: {
      value: (_vm.addressType.name),
      callback: function($$v) {
        _vm.$set(_vm.addressType, "name", $$v)
      },
      expression: "addressType.name"
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.first('name')))])], 1), _c('md-field', {
    class: {
      'md-invalid': _vm.errors.has('description')
    }
  }, [_c('label', [_vm._v("Описание")]), _c('md-textarea', {
    attrs: {
      "name": "description"
    },
    model: {
      value: (_vm.addressType.description),
      callback: function($$v) {
        _vm.$set(_vm.addressType, "description", $$v)
      },
      expression: "addressType.description"
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('description')),
      expression: "errors.has('description')"
    }],
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.first('description')))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4da9e833","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/address/views/AddressType.vue
// module id = 1133
// module chunks = 0